import React, { useState } from "react";
import axios from "axios";

export function Login({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await axios.post("/api/auth/login", { email, password }, { withCredentials: true });
      onLogin();
    } catch (err) {
      setError("Login failed. Check your credentials.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#000", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "#111", border: "1px solid #333", borderRadius: "12px", padding: "40px", width: "360px" }}>
        <h1 style={{ color: "#00ff88", fontFamily: "monospace", textAlign: "center", marginBottom: "8px", letterSpacing: "4px" }}>L E V E L S</h1>
        <p style={{ color: "#666", textAlign: "center", marginBottom: "32px", fontSize: "14px" }}>Trading System</p>
        {error && <div style={{ background: "#ff000022", border: "1px solid #ff4444", color: "#ff4444", padding: "10px", borderRadius: "6px", marginBottom: "16px", fontSize: "14px" }}>{error}</div>}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: "16px" }}>
            <label style={{ color: "#888", fontSize: "12px", display: "block", marginBottom: "6px" }}>EMAIL</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              style={{ width: "100%", background: "#1a1a1a", border: "1px solid #333", borderRadius: "6px", padding: "10px", color: "#fff", fontSize: "14px", boxSizing: "border-box" }}
              required
            />
          </div>
          <div style={{ marginBottom: "24px" }}>
            <label style={{ color: "#888", fontSize: "12px", display: "block", marginBottom: "6px" }}>PASSWORD</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ width: "100%", background: "#1a1a1a", border: "1px solid #333", borderRadius: "6px", padding: "10px", color: "#fff", fontSize: "14px", boxSizing: "border-box" }}
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            style={{ width: "100%", background: "#00ff88", color: "#000", border: "none", borderRadius: "6px", padding: "12px", fontWeight: "bold", fontSize: "14px", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}
          >
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <p style={{ color: "#444", textAlign: "center", fontSize: "12px", marginTop: "24px" }}>Private access only</p>
      </div>
    </div>
  );
}
